import { Divider, Typography } from 'antd';
import { useTranslation } from 'react-i18next';

import { UserInfoLink } from 'modules';

import convertFractionToPercent from 'utils/math/convertFractionToPercent';

import { ICommissionDetails, ISchemeDetailsProps } from './SchemeDetails.types';

import './SchemeDetails.styles.scss';

const { Text } = Typography;

const CommissionDetails = ({ title, poolCommission, beneficiaries, totalCommission }: ICommissionDetails) => {
  const { t } = useTranslation();

  const noBeneficiaries = !beneficiaries || !beneficiaries?.length;

  return (
    <div className="np-edit-partner-scheme-details__info">
      <Text className="np-edit-partner-scheme-details__info-title">{t(title)}</Text>

      <div className="np-edit-partner-scheme-details__info-block-wrapper">
        <div className="np-edit-partner-scheme-details__info-block">
          <Text className="np-edit-partner-scheme-details__info-block-title">{t('form.label.pool')}:</Text>
          <Text strong className="np-edit-partner-scheme-details__info-block-desc">
            {convertFractionToPercent(poolCommission, { fixed: 2 })}
          </Text>
        </div>

        {!noBeneficiaries &&
          beneficiaries.map(user => (
            <div key={user.uid} className="np-edit-partner-scheme-details__info-block">
              <Text strong className="np-edit-partner-scheme-details__info-block-title">
                <UserInfoLink user={user} fontSize={14} />:
              </Text>
              <Text strong className="np-edit-partner-scheme-details__info-block-desc">
                {convertFractionToPercent(user.commission, { fixed: 2 })}
              </Text>
            </div>
          ))}
      </div>

      {!noBeneficiaries && <Divider />}

      {!noBeneficiaries && (
        <div className="np-edit-partner-scheme-details__info-block m-10">
          <Text className="np-edit-partner-scheme-details__info-block-title">{t('form.label.totalComission')}:</Text>
          <Text strong className="np-edit-partner-scheme-details__info-block-desc">
            {convertFractionToPercent(totalCommission, { fixed: 2 })}
          </Text>
        </div>
      )}
    </div>
  );
};

const SchemeDetails = ({ scheme, ...props }: ISchemeDetailsProps) => {
  return (
    scheme && (
      <div className="np-edit-partner-scheme-details" {...props}>
        <CommissionDetails title="form.label.PpsBenefeciaries" {...scheme.pps} />
        <CommissionDetails title="form.label.PplnsBenefeciaries" {...scheme.pplns} />
      </div>
    )
  );
};

export default SchemeDetails;
